import { POST } from '@/server/http';
import URLS from '@/server/urls';

export default async ({
    id = 0,
    status: inputStatus = 0, // 0:启用, 1:禁用
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.dictionary.setStatus, {
        id,
        status: inputStatus,
    }, options);
    if (error) return { error, status };
    return content || { id, status };
};
